export const BD_PARTNER = {
  id: "bd-partner-ksa-001",
  title: "Independent Business Development Partner – Saudi Arabia",
  location: "Saudi Arabia",
  type: "Independent / Commission-Based Partnership",
  category: "Business Development",
  applyEmail: "riyadh@notionminds.sa",
  sections: [
    {
      heading: "About the Opportunity",
      paragraphs: [
        "The Business Development Partner will be responsible for identifying and developing new business opportunities for Notion Minds Systems across Saudi Arabia. We are particularly interested in professionals who have existing relationships with:",
      ],
      chips: ["CIOs", "CTOs", "IT Directors", "Heads of Technology", "Procurement", "Vendor Management", "Business & Technology Leaders"],
      after: "The role is relationship-driven and focused on generating qualified opportunities rather than high-volume cold calling.",
    },
    {
      heading: "Our Technology Capabilities — IT Services We Deliver in Saudi Arabia",
      paragraphs: [
        "As an Independent Business Development Partner, you will introduce organizations to the full breadth of Notion Minds Systems' technology and IT services capabilities in Saudi Arabia, including:",
      ],
      groups: [
        { name: "Application Development", items: "Java, .NET, React, Angular, Python, Node.js, APIs, Microservices, Enterprise Integration and Cloud" },
        { name: "Custom Software Development", items: "Solution Architecture, UI/UX, Enterprise Applications, Application Modernization, Cloud Migration, Integration, Maintenance & Support" },
        { name: "Software Testing", items: "Functional, Automation, API, Performance, Security, Mobile, Regression, Integration, Database & ETL Testing and Test Management" },
        { name: "DevOps & Cloud", items: "CI/CD, Docker, Kubernetes, OpenShift, Terraform, Ansible, Git and Azure DevOps" },
        { name: "Data Engineering & Analytics", items: "Data Warehousing, ETL, SQL, Power BI, Tableau and Data Migration" },
        { name: "Cybersecurity", items: "Vulnerability Assessment, Penetration Testing, Secure Code Review, SAST, DAST, API Security Testing and Cloud Security Assessment" },
        { name: "Resource Augmentation", items: "Solution Architects, Technical Leads, Developers, Business Analysts, Project Managers, DevOps Engineers, QA Engineers, DBAs, Security Consultants and Production Support Engineers" },
        { name: "Banking & Financial Services", items: "Core Banking, Retail & Corporate Banking, Digital Banking, Payments, Cards, Lending, Treasury, Trade Finance, AML, KYC, CRM and Open Banking" },
      ],
    },
    {
      heading: "Key Responsibilities",
      bullets: [
        "Identify and introduce qualified prospective clients in Saudi Arabia.",
        "Leverage existing professional relationships to access senior decision-makers.",
        "Generate opportunities for technology services, projects and specialized resources.",
        "Arrange introductions and meetings with relevant stakeholders.",
        "Understand client requirements and coordinate with the Notion Minds Systems team.",
        "Support qualified opportunities through requirement gathering, proposals and commercial discussions.",
        "Develop new accounts and help build recurring business relationships.",
        "Maintain regular updates on opportunities, contacts and next steps.",
      ],
    },
    {
      heading: "What Notion Minds Systems Provides",
      bullets: [
        "Company profile and capability presentation",
        "Service and solution information",
        "Technical and pre-sales support",
        "Relevant resource profiles and CVs",
        "Proposal preparation support",
        "Commercial support",
        "Delivery and implementation support",
      ],
    },
    {
      heading: "Who We Are Looking For",
      bullets: [
        "Proven experience in IT services, technology sales, consulting, outsourcing, software, cybersecurity, cloud, digital transformation or enterprise solutions",
        "An established network within the Saudi business and technology ecosystem",
        "Existing relationships with senior technology and business decision-makers",
        "Experience generating B2B enterprise opportunities",
        "Strong understanding of the Saudi market",
        "Excellent communication and relationship-building skills",
        "Ability to work independently and develop opportunities without day-to-day supervision",
        "Arabic and English communication skills preferred",
      ],
    },
    {
      heading: "Engagement Model — Independent / Commission-Based",
      paragraphs: [
        "This is an Independent / Commission-Based Partnership — it is not a salaried employment position.",
        "The Business Development Partner will earn commission on qualified business originated through their direct efforts, based on the agreed commercial arrangement and subject to customer payments being received by Notion Minds Systems. The commission structure and other commercial terms will be discussed with shortlisted candidates.",
      ],
    },
    {
      heading: "Who Should Apply?",
      paragraphs: [
        "This commission-based business development opportunity in Saudi Arabia is particularly suitable for an experienced professional who already has strong relationships in the Saudi technology and enterprise market and can convert those relationships into genuine business opportunities. We are especially interested in candidates who can demonstrate:",
      ],
      chips: ["Who you know", "Which organizations you can access", "What type of technology business you can originate"],
    },
  ],
};
